import { createRoot } from 'react-dom/client';
import PeopleDirectory from './PeopleDirectory';
import './people-client.css';

const MOUNT_ATTR = 'data-people-client-mount';

const mounted = new WeakSet<HTMLElement>();

function readEndpoint(el: HTMLElement): string {
  const ds = el.dataset.endpoint;
  if (ds && ds.trim()) return ds.trim();
  return '/workfolio.php';
}

function mountPeopleClient(container: HTMLElement) {
  if (mounted.has(container) || container.hasAttribute(MOUNT_ATTR)) {
    return;
  }
  try {
    const root = createRoot(container);
    root.render(<PeopleDirectory endpoint={readEndpoint(container)} />);
    mounted.add(container);
    container.setAttribute(MOUNT_ATTR, 'true');
  } catch (error) {
    console.error('[PeopleClient] Error mounting component:', error);
  }
}

function initializePeopleClients() {
  document.querySelectorAll<HTMLElement>(`.new-peopleClient:not([${MOUNT_ATTR}])`).forEach(mountPeopleClient);
}

const rootContainer = document.getElementById('root');
if (rootContainer) {
  const root = createRoot(rootContainer);
  root.render(<PeopleDirectory endpoint={readEndpoint(rootContainer)} />);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePeopleClients);
} else {
  setTimeout(initializePeopleClients, 0);
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        if (element.classList?.contains('new-peopleClient')) {
          mountPeopleClient(element);
        }
        element.querySelectorAll<HTMLElement>(`.new-peopleClient:not([${MOUNT_ATTR}])`).forEach(mountPeopleClient);
      }
    });
  });
});

if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
}
